import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import TextInput from "../TextInput/TextInput";
import CustomSelect from "../Select/Select";
import "./PresetStyle.css";
import { RootState } from "../../store";
import { getPresetList, trimMedia } from "@/store/media/media.action";

import { connect, ConnectedProps } from "react-redux";
import {
  emptyAssetDetails,
  emptyMediaDetails,
} from "@/store/media/media.slice";
import { getSearchedListMedia } from "@/store/media/media.action";

import { callRegisterMediaOnCms } from "@/store/upload/upload.action";
import ImageUpload from "../ImageUpload/ImageUpload";
import { getListMedia } from "@/store/media/media.action";
import VideoTrimmer from "../VideoTrimmer/VideoTrimmer";
import { updateModal } from "@/store/app/app.slice";
import { getMedia } from "@/store/media/media.action";

interface RenderCreateMetaPresetProps {
  item?: any;
  onSubmit?: (payload: any) => void;
  presetData?: any;
  isEdit?: boolean;
  OnCloseModal?: any;
  isPreview?: boolean;
  readOnlyMode?: boolean;
  isPreset?: boolean;
  setIsBrandingBtnDisabled?: (isDisabled: boolean) => void;
  setDuration?: (duration: number) => void;
}

type ModalType = "clone" | "mediaDetails" | "socialPublish" | null;

const BrandingPreset = ({
  item,
  preMediaList,
  postMediaList,
  getSearchedListMedia,
  trimMedia,
  onSubmit,
  callRegisterMediaOnCms,
  presetData,
  mediaList,
  getListMedia,
  isEdit,
  OnCloseModal,
  isPreview,
  readOnlyMode,
  isPreset,
  getMedia,
  media,
  bunchProductList,
  setIsBrandingBtnDisabled,
  presetList,
}: Props) => {
  const [isTrimmerOpen, setIsTrimmerOpen] = useState(true);
  const [duration, setDuration] = useState(0);

  const [initialCanvasOverlay, setInitialCanvasOverlay] = useState({
    showCanvasOverlay: false,
    textOverlays: [],
    logoOverlays: [],
    slateOverlays: [],
  });

  const DummyVideoId = "fnpmebg6og";

  useEffect(() => {
    getMedia({ id: DummyVideoId });
  }, []);

  const [canvasOverlay, setCanvasOverlay] = useState({
    showCanvasOverlay: false,
    textOverlays: [] as Array<{
      id: string;
      text: string;
      fontSize: number;
      fontColor: string;
      backgroundColor: string;
      position: { x: number; y: number };
      visible: boolean;
      isBold?: boolean;
      isItalic?: boolean;
      isUnderline?: boolean;
      padding?: number;
      rotation?: number;
      opacity?: number;
    }>,
    logoOverlays: [] as Array<{
      id: string;
      url: string;
      position: { x: number; y: number };
      size: { width: number; height: number };
      visible: boolean;
      opacity?: number;
      rotation?: number;
    }>,
    slateOverlays: [] as Array<{
      id: string;
      url: string;
      position: { x: number; y: number };
      size: { width: number; height: number };
      visible: boolean;
      isSlate: boolean;
      duration?: number;
      autoHide?: boolean;
      isPreRoll?: boolean;
      isPostRoll?: boolean;
    }>,
  });

  useEffect(() => {
    if (item?.meta?.duration && item.meta.duration > 0) {
      const videoDuration = item.meta.duration;
      setDuration(videoDuration);
    } else {
      setDuration(0);
    }
  }, [item?.meta?.duration]);

  const handleSetConvasOverlay = (params: any) => {
    setCanvasOverlay({ ...canvasOverlay, ...params });

    setInitialCanvasOverlay({
      ...initialCanvasOverlay,
      ...params.slateOverlays,
    });
  };

  useEffect(() => {
    if (!presetData) {
      setInitialCanvasOverlay({
        showCanvasOverlay: true,
        textOverlays: [],
        logoOverlays: [],
        slateOverlays: [],
      });
    }
    if (presetData?.branding) {
      setInitialCanvasOverlay({
        showCanvasOverlay: true,
        textOverlays: presetData.branding[0].textOverlays,
        logoOverlays: presetData.branding[0].logoOverlays,
        slateOverlays: [],
      });
    }
  }, [presetData]);

  const formik = useFormik({
    initialValues: {
      presetName: presetData?.name || "",
      status: presetData?.status || "",
      visibility: presetData?.team || [],
    },
    validationSchema: Yup.object({
      presetName: Yup.string()
        .required("Preset Name is required")
        .test(
          "unique-preset-name",
          "Same Name is not allowed",
          function (value) {
            if (!value || !presetList || presetList.length === 0) return true;

            const currentVisibility = this.parent.visibility || [];

            const duplicateExists = presetList.some((presetItem: any) => {
              if (presetItem.name !== value) return false;
              if (presetItem.type !== "branding") return false;
              if (isEdit && presetItem.id === presetData?.id) return false;
              const itemteam = presetItem.team || [];
              if (itemteam.length === 0) {
                return false;
              }
              return currentVisibility.some((vis: string) =>
                itemteam.includes(vis)
              );
            });

            return !duplicateExists;
          }
        ),
      status: Yup.string().required("Status is required"),
      visibility: Yup.array()
        .of(Yup.string())
        .min(1, "At least one visibility is required")
        .required("Visibility is required"),
    }),
    onSubmit: async (values) => {
      const errors = await formik.validateForm();
      formik.setFieldError("presetName", errors.presetName as string);
      formik.setFieldTouched("presetName", true);
      formik.handleBlur("presetName");
      if (Object.keys(errors).length > 0) {
        return;
      }

      const payload = {
        ...values,

        branding: [
          {
            textOverlays: canvasOverlay.textOverlays,
            logoOverlays: canvasOverlay.logoOverlays,
            pre_slate: canvasOverlay?.slateOverlays?.[0]?.id,
            post_slate: canvasOverlay?.slateOverlays?.[1]?.id,
          },
        ],
        name: values.presetName,
        status: values.status,
        team: values.visibility,
        type: "branding",
      };

      if (onSubmit) {
        onSubmit(payload);
      }
    },
  });

  const getBasePermission = (permission: string): string => {
    return permission;
  };

  function processPermissionForSelect(array: string[]) {
    const newarray = array?.map((str) => {
      return getBasePermission(str);
    });
    return newarray;
  }

  const handlePermissionChange = (values: string[], key: string) => {
    const newProducers = values?.map((value) => value);

    formik.setFieldValue(key, newProducers);
  };

  const deepEqualIgnoreExtraKeys = (a: any, b: any): boolean => {
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      return a.every((item, index) => deepEqualIgnoreExtraKeys(item, b[index]));
    }

    if (typeof a === "object" && typeof b === "object" && a && b) {
      return Object.keys(a).every((key) =>
        deepEqualIgnoreExtraKeys(a[key], b[key])
      );
    }

    return a === b;
  };
  useEffect(() => {
    const initialValues = formik.initialValues;
    const currentValues = formik.values;

    const basicFieldsHaveChanges = !deepEqualIgnoreExtraKeys(
      initialValues,
      currentValues
    );

    const canvasOverlayHasChanges = !deepEqualIgnoreExtraKeys(
      initialCanvasOverlay,
      canvasOverlay
    );

    const shouldEnableButton =
      basicFieldsHaveChanges || canvasOverlayHasChanges;
    setIsBrandingBtnDisabled?.(!shouldEnableButton);
  }, [
    formik.values,
    formik.initialValues,
    canvasOverlay,
    setIsBrandingBtnDisabled,
  ]);

  const handleReset = () => {
    const currentDuration = duration > 0 ? duration : item?.meta?.duration || 0;
    setDuration(currentDuration);
    setCanvasOverlay(initialCanvasOverlay);
  };

  const handleTrimmerClose = () => {
    setIsTrimmerOpen(false);
    handleReset();
    if (OnCloseModal) {
      OnCloseModal();
    }
  };

  const openModal = (modalType: ModalType) => {};

  useEffect(() => {
    const handleSubmit = () => {
      formik.handleSubmit();
    };
    window.addEventListener("createMetaPreset", handleSubmit);

    return () => {
      window.removeEventListener("createMetaPreset", handleSubmit);
    };
  }, []);

  return (
    <>
      {!isPreview && (
        <div
          className="row row-margin gx-4 gy-3"
          style={{ backgroundColor: "#FCFAFA" }}
        >
          <div className="col-md-4 mt-0">
            <TextInput
              label="Preset Name"
              name="presetName"
              value={formik.values.presetName}
              onChange={(e: any) => {
                formik.setFieldValue("presetName", e.target.value);
              }}
              onBlur={formik.handleBlur}
              showRequired={true}
              placeholder="Enter Preset Name"
              error={formik.errors.presetName as string}
              touched={formik.touched.presetName as boolean}
            />
          </div>
          <div className="col-md-4 mt-0">
            <CustomSelect
              // value={formik.values.visibility}
              value={processPermissionForSelect(formik.values.visibility)}
              // value={prevVideoCredit}
              handleChange={(newValue: any) => {
                handlePermissionChange(
                  newValue.map((option: any) => option.value),
                  "visibility"
                );
              }}
              label="team"
              multiSelect={true}
              placeholder="Team/Property"
              checkBox={true}
              showRequired={true}
              options={
                bunchProductList
                  ?.filter(
                    (item: any) =>
                      item?.access === "admin" || item?.access === "write"
                  )
                  ?.map((item: any) => ({
                    label: item?.name,
                    value: item?.id,
                  })) || []
              }
              updatedOptions={
                bunchProductList
                  ?.filter(
                    (item: any) =>
                      item?.access === "admin" || item?.access === "write"
                  )
                  ?.map((item: any) => ({
                    label: item?.name,
                    value: item?.id,
                  })) || []
              }
              hideArrow={true}
              error={formik.errors.visibility as string}
              touched={formik.touched.visibility as unknown as boolean}
              handleBlur={formik.handleBlur}
            />
          </div>
          <div className="col-md-4 mt-0">
            <CustomSelect
              value={formik.values.status}
              handleChange={(newValue: any) => {
                formik.setFieldValue("status", newValue.value);
              }}
              label="Status"
              multiSelect={false}
              placeholder="Select Status"
              showRequired={true}
              options={[
                {
                  label: "Active",
                  value: 1,
                },
                {
                  label: "Inactive",
                  value: 2,
                },
              ]}
              updatedOptions={[
                { label: "Active", value: "1" },
                { label: "Inactive", value: "2" },
              ]}
              hideArrow={true}
              error={formik.errors.status as string}
              touched={formik.touched.status as boolean}
            />
          </div>
        </div>
      )}
      {isTrimmerOpen && (
        <VideoTrimmer
          isOpen={isTrimmerOpen}
          onClose={handleTrimmerClose}
          media={media}
          onTrimComplete={(trimmedMedia: any) => {
            setIsTrimmerOpen(false);
            openModal("mediaDetails");
          }}
          trimMedia={trimMedia}
          updateModal={updateModal}
          // presetList={presetList}
          preMediaList={preMediaList}
          postMediaList={postMediaList}
          getListMedia={getListMedia}
          getSearchedListMedia={getSearchedListMedia}
          getPresetList={getPresetList}
          getMedia={getMedia}
          callRegisterMediaOnCms={callRegisterMediaOnCms}
          isPreset={isPreset}
          ImageUpload={ImageUpload}
          currentMedia={item}
          mediaList={mediaList}
          handleSetConvasOverlay={handleSetConvasOverlay}
          presetData={presetData}
          isEdit={isEdit}
          OnCloseModal={OnCloseModal}
          isPreview={isPreview}
          readOnlyMode={readOnlyMode}
          isShowModal={false}
          setMediaDuration={setDuration}
        />
      )}
    </>
  );
};
const mapState = (state: RootState) => ({
  preMediaList: state.media.preMediaList.list,
  postMediaList: state.media.postMediaList.list,
  mediaList: state.media.mediaList.list,
  media: state.media.mediaDetails.media,
  bunchProductList: state.constants.bunchProductList.list,
  presetList: state.media.presetList.list,
});

const mapDispatch = {
  emptyAssetDetails,
  emptyMediaDetails,
  getSearchedListMedia,
  trimMedia,
  callRegisterMediaOnCms,
  getListMedia,
  getPresetList,
  getMedia,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & RenderCreateMetaPresetProps;
export default connector(BrandingPreset);
